import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { PerfMonitorService, PerfStats } from '../../../shared/service/perf-monitor.service';

@Component({
  selector: 'app-perf-overlay',
  templateUrl: './perf-overlay.component.html',
  styleUrls: ['./perf-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerfOverlayComponent implements OnInit, OnDestroy {
  stats$!: Observable<PerfStats>;
  private destroy$ = new Subject<void>();
  visible = true;

  constructor(private perf: PerfMonitorService) {}

  ngOnInit(): void {
    this.perf.start(1000);
    this.stats$ = this.perf.getStats$();
  }

  toggle(): void {
    this.visible = !this.visible;
  }

  close(): void {
    this.visible = false;
    this.perf.stop();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.perf.stop();
  }
}
